<template>
    <div class="user">
        <van-nav-bar
                title="填写申请信息"
                left-arrow
                :fixed='true'
                @click-left="onClickBack"
            />
        <div class="userInfo">
            <van-cell-group>
                <van-field
                    placeholder="可上传证件照正面自动识别"
                    label="姓名"
                    left-icon="contact"
                    v-model="userInfo.custName"
                />
                <van-field
                    placeholder="上传证件照正面自动识别"
                    label="身份证号"
                    left-icon="idcard"
                    v-model="userInfo.psptId"
                    readonly
                />
                <van-field
                    placeholder="可上传证件照正面自动识别"
                    label="证件地址"
                    left-icon="shrink"
                    v-model="userInfo.psptLocation"
                />
                <van-field
                    placeholder="请输入联系号码"
                    label="联系号码"
                    left-icon="phone-o"
                    maxlength=11
                    v-model="userInfo.contractPhone"
                />
            </van-cell-group>
        </div>
        <div class="addressInfo">
            <van-cell-group>
                <van-field
                    placeholder="请选择快递方式"
                    label="快递方式"
                    left-icon="logistics"
                    readonly
                    v-model="userInfo.logistics.label"
                >
                </van-field>
                <van-field
                    placeholder="请选择收货地址"
                    label="收货地址"
                    disabled
                    left-icon="home-o"
                    @click="showAddress"
                    v-model="userInfo.takeAddress"
                />
                <van-field
                    placeholder="请输入详细地址"
                    label="详细地址"
                    type="textarea"
                    row='1'
                    left-icon="wap-home"
                    v-model="userInfo.takeAddressDetail"
                />
            </van-cell-group>
        </div>
        <div class="waringText">
            根据工信部要求,需实名购卡,请上传本人证件
        </div>
        <div class="picInfo">
            <van-panel title="证件照" desc="上传证件材料（身份证照片上的信息必须清晰可见）">
                <PictureCamera class="picInfo-cell" :picWidth.sync='picWidth' :picHeight.sync='picHeight' :picOver.sync='picOver[0].imgPath' :resultImage.sync='userInfo.picNameZ' :desc.sync='picOver[0].desc' :imageInfoObj.sync='imageZInfoObj' :isAnalyze.sync='isAnalyzeZ'  :uploadImagePath.sync='uploadImagePath' :readImagePath.sync='readImagePath' />
                <PictureCamera class="picInfo-cell" :picWidth.sync='picWidth' :picHeight.sync='picHeight' :picOver.sync='picOver[1].imgPath' :resultImage.sync='userInfo.picNameF' :desc.sync='picOver[1].desc'  :uploadImagePath.sync='uploadImagePath' :readImagePath.sync='readImagePath' />
                <PictureCamera class="picInfo-cell" :picWidth.sync='picWidth' :picHeight.sync='picHeight' :picOver.sync='picOver[2].imgPath' :resultImage.sync='userInfo.picNameT' :desc.sync='picOver[2].desc'  :uploadImagePath.sync='uploadImagePath' :readImagePath.sync='readImagePath' />
            </van-panel>
        </div>
        <div class="submitInfo">
            <div class="submitInfo-checked">
                <input type="checkbox" v-model="userInfo.readContract" />
                <span @click="showContractFile" >我已阅读并同意《民生通讯入网协议》</span>
            </div>
            <div class="submitInfo-btn">
                <van-button type="primary" size="large" @click="submitData" loading-text='正在提交...'>提交订单</van-button>
            </div>
            <div class="submitInfo-warning">
                温馨提示：
                <div class="submitInfo-warning-item">1、订单提交成功后,将会进行审核</div>
                <div class="submitInfo-warning-item">2、您可通过我的订单记录进行查询相关进度。</div>
            </div>
        </div>
         <!-- confirm-button-text	= "我已阅读"
            confirm-button-color='rgb(7, 193, 96);background-color:red;' -->
        <ContractInfo :showContract.sync='showContract' :popuTime.sync='popuTime' :userA.sync='userInfo.custName' :readContract.sync='userInfo.readContract' @showContractClick='showContractClick'></ContractInfo>

        <van-popup v-model="showAddressPop" position="bottom">
            <van-area title="收货地址" :area-list="areaList"  @confirm='confirmChoiceAddress' @cancel="cancelChoiceAddress"/>
        </van-popup>
        <van-popup v-model="showLoading" style="background-color:#4C4C4C;" :lazy-render=false :close-on-click-overlay=false >
            <van-loading size="24px" vertical>{{loadingText}}</van-loading>
        </van-popup>
    </div>
    
</template>

<script>
    import AreaList from '../../common/area';
    import {dataURLtoBlob} from '../../common/functionUtil';
    import {setAesString,getAesString} from "../../config/date";
    import ContractInfo from '@/components/ContractInfo';
    import PictureCamera from '@/components/PictureCamera';
    import {formatTime} from '../../common/functionUtil';
    import zmOver from '@/assets/half_year_zm.jpg';
    import fmOver from '@/assets/half_year_bm.jpg';
    import tmOver from '@/assets/half_year_sc.jpg';

export default {
    name: 'userInfo',
    components: {
       ContractInfo,
       PictureCamera
    },
    data(){
        return{
            popuTime:'',
            picWidth:'280px',
            picHeight:'250px',
            uploadImagePath:this.$api.uploadNetWorkFileBaseUrl,
            readImagePath:this.$api.readNetWorkImagePath,
            picOver:[
                {desc:'Z',imgPath:zmOver},
                {desc:'F',imgPath:fmOver},
                {desc:'T',imgPath:tmOver}
            ],
            showLoading:false,
            loadingText:'加载中,请稍等...',
            useData:null,
            showContract: false,
            showAddressPop: false,
            areaList:AreaList,
            contractFileInfo:[],
            imageZList:[],
            imageFList:[],
            imageTList:[],
            imageZInfoObj:{},
            isAnalyzeZ:true,//是否解析证件照
            userInfo:{
                activityCode:'',
                readContract:false,
                serialNumber:'',
                packageId:'',
                custName:'',
                psptId:'',
                nation:'',
                birthday:'',
                psptLocation:'',
                contractPhone:'',
                logistics:{text:'中通快递',label:'中通快递',value:10},
                takeAddress:'',
                takeAddressDetail:'',
                picNameZ:null,
                picNameF:null,
                picNameT:null
            }
        }
    },
    watch:{
        imageZInfoObj(val){
            if(val !=''){
                this.userInfo.psptId = val.data.IDCard;
                this.userInfo.custName = val.data.name;
                this.userInfo.psptLocation =val.data.address;
                this.userInfo.nation = val.data.nation;
                this.userInfo.birthday = val.data.birthday;
                this.userInfo.sex = val.data.sex;
            }
        }
    },
    created(){
        this.numberObj = sessionStorage.getItem(setAesString("numberObj"));
        this.packageObj = sessionStorage.getItem(setAesString("packageObj"));
        this.activityCode = sessionStorage.getItem(setAesString("activityCode"));
        if(this.numberObj == null){
            this.$dialog.alert({
                message: '请先返回首页选择中意号码'
            }).then(() => {
                //提交数据
                this.$router.push({
                    path:'/aIdx'
                });
            });
            return;
        }
        if(this.packageObj == null){
            this.$dialog.alert({
                message: '请先返回首页选择号码对应的套餐'
            }).then(() => {
                //提交数据
                this.$router.push({
                    path:'/aIdx'
                });
            });
            return;
        }
        
        if(this.activityCode == null){
            this.$dialog.alert({
                message: '请首页重新操作输入有效活动码'
            }).then(() => {
                //提交数据
                this.$router.push({
                    path:'/aIdx'
                });
            });
            return;
        }

        this.numberObj = JSON.parse(getAesString(this.numberObj));
        this.packageObj = JSON.parse(getAesString(this.packageObj));
        this.activityCode = JSON.parse(getAesString(this.activityCode));

        //去除全国这个选项
        delete this.areaList.province_list[100000];
        this.popuTime =  this.formatTime(new Date(),'yyyy 年 MM 月 dd 日 ');
    },
    methods: {
        formatTime,
        dataURLtoBlob,
        onClickBack() {
            this.$router.back(-1);//返回上一层
        },
        showAddress(){
            //显示地址选择
            this.showAddressPop = true;
        },
        confirmChoiceAddress(obj){
            //确认地址选择
            this.showAddressPop = false;
            //确认地址选择，code 代表被选中的地区编码， name 代表被选中的地区名称
            this.userInfo.takeAddress = obj[0].name+" "+obj[1].name+" "+obj[2].name;
        },
        cancelChoiceAddress(){
            //取消地址选择
            this.showAddressPop = false;
        },
        showContractFile(){
            //显示协议信息
            this.showContract = true;
            this.userInfo.readContract = true;
        },
        showContractClick(){
            //隐藏协议
            this.showContract = false;
            this.userInfo.readContract = true;

        },
        submitData(){
            if(this.userInfo.custName == ''){
                this.$toast({
                    message: '姓名不能为空',
                    icon: 'fail'
                });
                return;
            }
            if(this.userInfo.psptId == ''){
                this.$toast({
                    message: '证件号不能为空',
                    icon: 'fail'
                });
                return;
            }
            if(this.userInfo.psptId.length < 18){
                this.$toast({
                    message: '证件号格式错误',
                    icon: 'fail'
                });
                return;
            }
            if(this.userInfo.psptLocation == ''){
                this.$toast({
                    message: '请填写证件上门地址',
                    icon: 'fail'
                });
                return;
            }
            if(this.userInfo.contractPhone == ''){
                this.$toast({
                    message: '请填写联系号码',
                    icon: 'fail'
                });
                return;
            }
            if(this.userInfo.contractPhone.length != 11){
                this.$toast({
                    message: '请填写有效联系号码',
                    icon: 'fail'
                });
                return;
            }
            if(this.userInfo.takeAddress == ''){
                this.$toast({
                    message: '请选择收货地址',
                    icon: 'fail'
                });
                return;
            }
            if(this.userInfo.takeAddressDetail == ''){
                this.$toast({
                    message: '请选择收货详细地址',
                    icon: 'fail'
                });
                return;
            }
            if(this.userInfo.picNameZ == null || this.userInfo.picNameZ == ''){
                this.$toast({
                    message: '请上传证件照正面',
                    icon: 'fail'
                });
                return;
            }
            if(this.userInfo.picNameF == null || this.userInfo.picNameF == '' ){
                this.$toast({
                    message: '请上传证件照反面',
                    icon: 'fail'
                });
                return;
            }
            if(this.userInfo.picNameT == null || this.userInfo.picNameT == ''){
                this.$toast({
                    message: '请上传手持证件照',
                    icon: 'fail'
                });
                return;
            }
            if(this.userInfo.logistics == ''){
                this.$toast({
                    message: '请选择收货的物流',
                    icon: 'fail'
                });
                return;
            }

            if(!this.userInfo.readContract){
                this.$toast({
                    message: '请先阅读《民生通信入网协议》',
                    icon: 'fail'
                });
                return;
            }


            var formdata={
                ...this.page,
                service : "user.saveActivityChoiceNumberInfo",
                choiceChannel:'weixin',
                sid:this.numberObj.sid,
                serialNumber:this.numberObj.serialNumber,
                packageId:this.packageObj.packageId,
                custName:this.userInfo.custName,
                psptId:this.userInfo.psptId,
                psptLocation:this.userInfo.psptLocation,
                contractPhone:this.userInfo.contractPhone,
                takeAddress:this.userInfo.takeAddress,
                takeAddressDetail:this.userInfo.takeAddressDetail,
                logistics:this.userInfo.logistics.text,
                nation:this.userInfo.nation,
                birthDay:this.userInfo.birthday,
                sex:this.userInfo.sex,
                picNameZ:this.userInfo.picNameZ,
                picNameF:this.userInfo.picNameF,
                picNameT:this.userInfo.picNameT,
                codeNum:this.activityCode
            }

            this.$dialog.confirm({
                message: '确认提交订单?'
            }).then(() => {
                this.$api.post("/mstx/pr/gateway.do", formdata,(res)=>{
                    //提交数据
                    this.$toast({
                        message: '订单提交成功,等待审核中',
                        icon: 'success'
                    });
                    sessionStorage.clear();
                    this.$router.push({
                        path:'/aIdx'
                    });
                },(res)=>{
                    this.$toast.fail(res.errorMsg);
                });
            }).catch(() => {
            });

            
        }
    }
}
</script>

<style lang="less">

.userInfo{
    margin-top: 47px;
}

.addressInfo{
    margin-top: 10px;
}

.waringText{
    text-align: center;
    font-size: 14px;
    color: red;
}

.dialog{
    &-button{
        width: 100%;
    }
}
.van-uploader__preview{
    width:320px;
    height:200px;
    position: relative;
}
.picInfo{
    margin-top: 10px;
    margin-bottom: 10px;
    &-cell{
        margin-bottom:30px;
    }
    &-upload{
        text-align: center;
        .van-uploader__preview{
            width: 300px;
            height: 200px;
            margin: 0px 0px;
        }
        .van-uploader__preview-image{
            width: 300px;
            height: 200px;
            text-align: center;
        }
        &-img{
            position: relative;
            width: 300px;
            height: 250px;
        }
    }
}

.submitInfo{
    width: 100%;
    height: 170px;
    margin: 10px auto;
    color: #20A0FF;
    text-align: center;
    &-checked{
        text-align: center;
        input{
            margin-right: 10px;
        }
    }
    &-btn{
        margin: 20px 10px;
    }
    &-warning{
        font-size: 12px;
        margin: 0px 10px;
        text-align: left;
        color:red;
        &-item{
            color:red;
            text-indent: 2em;
        }
    }
}

.van-cell__title{
    text-align: center;
}
</style>
